import { createContext, ReactNode, useContext, useState } from "react";

// Define the types for the context value

// Define the types for the context value
type ManagedSpecialUnitsContextValue<T> = T | undefined;

// Create the context with a default value undefined
const ManagedSpecialUnitsContext = createContext<ManagedSpecialUnitsContextValue<unknown>>(undefined);

type ManagedSpecialUnitsProviderProps = {
    children: ReactNode;
};

interface IManagedSpecialUnitsContext<T> {
    setHidePanelResponse: React.Dispatch<React.SetStateAction<boolean | null>>;
    hidePanelResponse: boolean | null;
    setSearchExist: React.Dispatch<React.SetStateAction<boolean | null>>;
    searchExist: boolean | null;
    dataSearch: Array<T>;
    setDataSearch: React.Dispatch<React.SetStateAction<Array<T>>>;
    updateData: number | null;
    setUpdateData: React.Dispatch<React.SetStateAction<number | null>>;
}

export function ManagedSpecialUnitsProvider<T>({ children }: Readonly<ManagedSpecialUnitsProviderProps>) {
	const [hidePanelResponse, setHidePanelResponse] = useState<boolean | null>(null);
	const [searchExist, setSearchExist] = useState<boolean | null>(null);
	const [dataSearch, setDataSearch] = useState<Array<T> | []>([]);
	const [updateData, setUpdateData] = useState<number | null>(null);

	return (
        <ManagedSpecialUnitsContext.Provider
            value={{
                setHidePanelResponse,
                hidePanelResponse,
                setSearchExist,
                searchExist,
                dataSearch,
                setDataSearch,
                updateData,
                setUpdateData,
            }}
        >
            {children}
        </ManagedSpecialUnitsContext.Provider>
    );
}

export function useManagedSpecialUnits<T>() {
    const context = useContext(ManagedSpecialUnitsContext);
    if (context === undefined) {
        throw new Error("useManagedSpecialUnits must be used within a ManagedSpecialUnitsProvider");
    }
    return context as IManagedSpecialUnitsContext<T>;
}
